// Featured products
window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

(function () {
  window.theme.FeaturedProducts = (function () {
    const defaults = {
      avoidReflow: true,
      prevNextButtons: false,
      groupCells: true,
      wrapAround: false,
    };

    function FeaturedProducts(container) {
      this.container = container;
      const sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector(`#FeaturedProducts-${sectionId}`);
      this.namespace = `.featuredProducts-${sectionId}`;

      if (!this.slideshow) {
        return;
      }

      window.theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      });
    }

    FeaturedProducts.prototype = {
      ...FeaturedProducts.prototype,
      init() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        // this.flickity = new window.theme.Slideshow(this.slideshow, defaults);
        const carousel = new Flickity('.featured-products__slider', {
          groupCells: true,
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          cellAlign: 'left',
        });
        this.navigation = this.container.querySelector('.slider-navigation');
        const goNext = this.navigation.querySelector('.arrow-next');
        const goPrev = this.navigation.querySelector('.arrow-previous');

        // Custom previous slide button
        goPrev.addEventListener('click', () => {
          carousel.previous();
        });

        // Custom next slide button
        goNext.addEventListener('click', () => {
          carousel.next();
        });

        // Disable the next/prev button if first or last slide
        carousel.on('select', (index) => {
          goPrev.disabled = index === 0;
          goNext.disabled = index === carousel.slides.length - 1;
        });

        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(
            function () {
              this.flickity.goToSlide(1);
            }.bind(this),
            1000
          );
        }
      },

      onUnload() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
    };

    return FeaturedProducts;
  })();

  function DOMready(callback) {
    if (document.readyState !== 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  DOMready(function () {
    window.theme.sections?.register('featured-products', window.theme.FeaturedProducts);
  });
})();

/**
 * Generate loader animation html
 */
const generateLoader = () => {
  const {loaderImage} = theme.settings;

  if (!loaderImage) return false;

  const loader = document.createElement('div');
  loader.classList.add('loading-logo');
  loader.style.backgroundImage = `url('${loaderImage}')`;

  return loader;
};

/**
 * Update variant image on swatch selection
 */
const gridSwatches = () => {
  const swatches = document.querySelectorAll('.variant-input');
  if (!swatches) return;

  function updateVariantImage(variantImages, option) {
    const loader = generateLoader();

    const selectedVariantIndex = [...variantImages].findIndex((image) =>
      image.dataset.options.includes(option)
    );

    variantImages.forEach((image, index) => {
      if (selectedVariantIndex < 0) return;

      const existingLoader = image.parentNode.querySelector('.loading-logo');

      if (index === selectedVariantIndex) {
        if (loader) {
          if (existingLoader) {
            existingLoader.classList.add('hidden');
            // Toggle back to the logo if image is not ready yet
            if (image.naturalWidth === 0) existingLoader.classList.remove('hidden');
          }

          if (!image.src) {
            if (!existingLoader) {
              try {
                image.parentNode.appendChild(loader);

                image.addEventListener(
                  'load',
                  () => {
                    image.parentNode.removeChild(loader);
                  },
                  {once: true}
                );
              } catch (error) {
                console.error('Error occurred while appending loader:', error);
              }
            }
          }
        }
        image.classList.remove('hidden');
      } else {
        image.classList.add('hidden');
      }
    });
  }

  swatches.forEach((swatch) => {
    const input = swatch.querySelector('input');
    if (!input) return;

    input.addEventListener('change', (e) => {
      const imagesContainer = e.target.closest('.grid-product__image-mask');
      if (!imagesContainer) return;

      const variantImages = imagesContainer.querySelectorAll('img');
      if (!variantImages) return;

      updateVariantImage(variantImages, e.target.value);
    });
  });
};

/**
 * Show loading animation on search
 */
const handleSearchLoader = () => {
  const searchModal = document.querySelector('.sl-search-wrapper');
  const loader = generateLoader();

  if (!loader) return;

  document.addEventListener('searchStarted', () => {
    searchModal.insertAdjacentElement('afterbegin', loader);
  });

  document.addEventListener('searchEnded', () => {
    loader.remove();
  });
};

function toggleMegaMenuBackground() {
  const megaMenuItem = document.querySelector('.site-nav--has-dropdown');

  if (!megaMenuItem) return;

  const wrapper = document.querySelector('#HeaderWrapper');
  const siteHeader = wrapper.querySelector('#SiteHeader');

  megaMenuItem.addEventListener('mouseenter', () => {
    if (!JSON.parse(siteHeader.dataset.overlay)) return;

    if (!siteHeader.classList.contains('site-header--stuck')) {
      wrapper.style.background = '#FFFFFF';
      wrapper.style.transition = 'background .5ms ease-in-out';
      wrapper.classList.remove('is-light');
    }
  });

  megaMenuItem.addEventListener('mouseleave', () => {
    if (!JSON.parse(siteHeader.dataset.overlay)) return;

    if (!siteHeader.classList.contains('site-header--stuck')) {
      wrapper.style.transition = 'background 1s ease';
      wrapper.style.background = 'none';
      wrapper.classList.add('is-light');
    }
  });
}

/**
 * Generate the necessary HTML as string based on the provided rating
 * @param {number} rating
 * @returns {string}
 */
window.theme.generateReviewStars = (rating) => {
  // The maximum review value
  const max = 5;

  return Array.from({length: max}, (_, i) => {
    // While the rating is grater than the maximum review value, add a full-star class
    const className = i < rating ? 'full-star' : 'empty-star';
    return `<span class="${className}"></span>`;
  }).join('');
};

/**
 * Returns the first provided word followed by the second one's first letter and a dot if there are two words
 * @param {string} name
 * @returns {string|*}
 */
window.theme.abbreviateName = (name) => {
  const pattern = /^(\S+)\s(\S)\S*/;
  const match = name.match(pattern);
  return match ? `${match[1]} ${match[2]}.` : name;
};

/**
 * Toggle the password visibility for an input
 */
window.theme.addPasswordToggle = (passwordInputId, toggleElement) => {
  const passwordInput = document.querySelector(passwordInputId);
  const btn = document.querySelector(toggleElement);
  function togglePasswordVisibility() {
    if (passwordInput.type === 'text') {
      passwordInput.type = 'password';
      btn.classList.remove('password-visible');
    } else {
      passwordInput.type = 'text';
      btn.classList.add('password-visible');
    }
  }

  btn.addEventListener('click', togglePasswordVisibility);
};

window.theme.initProductRecommendationSlider = () => {
  const arrows = document.querySelector('#sl-product-recommendations__arrows');
  const prevBtn = arrows?.querySelector('#sl-product-recommendations__arrows--left');
  const nextBtn = arrows?.querySelector('#sl-product-recommendations__arrows--right');

  const slider = new Flickity('#sl-product-recommendations__slider', {
    groupCells: true,
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    draggable: true,
    cellAlign: 'left',
  });

  // Custom previous slide button
  prevBtn?.addEventListener('click', () => {
    slider.previous();
  });

  // Custom next slide button
  nextBtn?.addEventListener('click', () => {
    slider.next();
  });

  // Disable the next/prev button if first or last slide
  slider.on('select', (index) => {
    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === slider.slides.length - 1;
  });
};

/**
 * Handle the animation for when a product is added to the cart
 */
const handleAddToCartToolTip = () => {
  const cartNotification = document.querySelector('.sl-cart__notification');
  const progressBar = cartNotification.querySelector('#sl-cart__notification-bar-filled');
  const tooltip = cartNotification.querySelector('#sl-cart__notification-bar');
  const addedToCartMessage = cartNotification.querySelector('#sl-cart__added-to-cart');
  const fastShippingMessage = cartNotification.querySelector('#sl-cart__fast_shipping');
  const animationDuration = 5000; // 5 seconds in milliseconds
  const startTime = performance.now();

  // Show the progress bar and hide the fast shipping message
  progressBar.style.setProperty('--progress-width', 100);
  fastShippingMessage.classList.add('hidden');
  tooltip.classList.remove('hidden');
  addedToCartMessage.classList.remove('hidden');

  const decreasePercentage = (currentTime) => {
    const elapsedTime = currentTime - startTime;
    const progress = Math.max(0, 100 - (elapsedTime / animationDuration) * 100);

    progressBar.style.setProperty('--progress-width', progress);

    if (progress > 0) {
      requestAnimationFrame(decreasePercentage);
    } else {
      // Hide the progress bar and added to cart message, and show the fast shipping message
      tooltip.classList.add('hidden');
      addedToCartMessage.classList.add('hidden');
      fastShippingMessage.classList.remove('hidden');
    }
  };

  // Start the animation
  requestAnimationFrame(decreasePercentage);
};

const initCustomSwatches = () => {
  const swatches = document.querySelectorAll('[data-variant-input-sl]');
  if (!swatches) return;

  const getVariantData = (wrapper, selected) => {
    const variantsJson = JSON.parse(wrapper.innerHTML);
    return variantsJson.find((variant) => variant.title === selected);
  };

  const handleUpdates = (selectedSwatch, parent) => {
    const {colorName} = selectedSwatch.target.dataset;
    const masterSelect = parent.querySelector('[data-product-select]');

    // Data to update on swatch change
    const price = parent.querySelector('[data-product-price] span');
    const priceWrapper = parent.querySelector('[data-product-price-wrap]');
    const savePrice = parent.querySelector('[data-save-price]');
    const comparePrice = parent.querySelector('[data-compare-price]');

    const image = parent.querySelector('[data-product-image]');
    const variantsJsonWrapper = parent.querySelector('[data-variant-json-sl]');

    const selectedVariant = getVariantData(variantsJsonWrapper, colorName);

    // Update form data
    if (!masterSelect) return;
    masterSelect.value = selectedVariant.id;

    // Update image
    image.src = selectedVariant.featured_image.src;

    // Update price
    price.innerText = theme.Currency.formatMoney(selectedVariant.price, theme.settings.moneyFormat);
    // Sale price, if necessary
    if (priceWrapper && selectedVariant.compare_at_price > selectedVariant.price) {
      comparePrice.innerText = theme.Currency.formatMoney(
        selectedVariant.compare_at_price,
        theme.settings.moneyFormat
      );
      priceWrapper.classList.remove('hide');
      price.classList.add('on-sale');

      let savings = selectedVariant.compare_at_price - selectedVariant.price;

      if (theme.settings.saveType === 'percent') {
        savings = `${Math.round((savings * 100) / selectedVariant.compare_at_price)}%`;
      } else {
        savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
      }

      savePrice.classList.remove('hide');
      savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
    }
  };

  swatches.forEach((swatch) => {
    const parent = swatch.closest('[data-custom-swatches]');
    const productForm = parent.querySelector('.product-single__form');
    /* eslint-disable no-new */
    new theme.AjaxProduct(productForm);
    swatch.addEventListener('change', (e) => handleUpdates(e, parent));
  });
};

const toggleCandleDescriptionBox = () => {
  const scentWrapper = document.querySelectorAll('.variant-wrapper__scent');

  if (!scentWrapper) return;

  scentWrapper.forEach((info) => {
    const infoIcon = info.querySelector('.info-icon');
    const descriptionBox = info.querySelector('.variant__short-description');
    const closeBtn = info.querySelector('.variant__close-info');

    if (!infoIcon || info.querySelector('.variant-description__wrapper:empty')) return;
    const showDescription = () => descriptionBox.classList.add('show');
    const hideDescription = () => descriptionBox.classList.remove('show');

    infoIcon.addEventListener('mouseenter', showDescription);
    descriptionBox.addEventListener('mouseleave', hideDescription);
    closeBtn.addEventListener('click', hideDescription);
  });
};

document.addEventListener('DOMContentLoaded', async () => {
  toggleMegaMenuBackground();
  gridSwatches();
  handleSearchLoader();
  initCustomSwatches();
  toggleCandleDescriptionBox();
});

document.addEventListener('cart-recommendations:init', async () => {
  initCustomSwatches();
});

document.addEventListener('collection:reloaded', () => {
  gridSwatches();
});

document.addEventListener('collection:pushup', () => {
  gridSwatches();
  // toggleCandleDescriptionBox();
});

document.addEventListener('collection:paginated', () => {
  gridSwatches();
  toggleCandleDescriptionBox();
});
document.addEventListener('recommendations:loaded', () => gridSwatches());
document.addEventListener('ajaxProduct:added', () => {
  handleAddToCartToolTip();
});

// Slide Cart Edits - Start
/* eslint-disable */
function scNewUpdateQty(lineItemKey, qty) {
  let formData = {
    id: lineItemKey,
    quantity: qty,
  };
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })
    .then(() => {
      window.SLIDECART_UPDATE();
    })
    .catch((error) => {
      console.log('Slide Cart Error:', error);
    });
}

window.SLIDECART_UPDATED = (cart) => {
  // cart icon bubble sync - start
  var el = document.querySelector('.cart-link__bubble');
  var cls = 'cart-link__bubble--visible';
  if (el) {
    cart.item_count > 0 ? el.classList.add(cls) : el.classList.remove(cls);
  }
  // cart icon bubble sync - end

  // fix quantity update for bxgy discounts - start
  const scQuantityButtons = document.querySelectorAll(
    '#slidecarthq .item .quantity-selector button:not(.modified), #slidecarthq .item button.remove:not(.modified)'
  );

  // change behavior for all quantity buttons in slide cart
  scQuantityButtons.forEach((button) => {
    button.classList.add('modified');
    button.addEventListener('click', (event) => {
      event.stopImmediatePropagation();

      const parentItem = button.closest('.item');
      const lineItemKey = parentItem?.getAttribute('data-line-item-key');
      const quantity = parentItem?.querySelector('.quantity-selector input')?.value;
      const buttonLabel = button.getAttribute('aria-label');
      let newQuantity;

      if (buttonLabel && buttonLabel.includes('remove')) {
        newQuantity = 0;
      } else if (buttonLabel && buttonLabel.includes('decrease')) {
        newQuantity = parseInt(quantity) - 1;
      } else if (buttonLabel && buttonLabel.includes('increase')) {
        newQuantity = parseInt(quantity) + 1;
      }

      if (lineItemKey && typeof newQuantity == 'number') {
        scNewUpdateQty(lineItemKey, newQuantity);
      }
    });
  });

  // disable all quantity text inputs in slide cart
  const scQuantityTextInputs = document.querySelectorAll(
    '#slidecarthq .item .quantity-selector input'
  );
  scQuantityTextInputs.forEach((txtInput) => {
    txtInput.setAttribute('disabled', '');
  });
  // fix quantity update for bxgy discounts - end

  // Modify cart item price display
  const itemPrice = document.querySelectorAll('#slidecarthq .item .price');
  const cartTotal = document.querySelector('#slidecarthq .slidecart-subtotal');

  function formatPrice(value) {
    const val = value.innerText.match(/^([^\d.,]+)([\d.,]+)$/);

    if (val && val[2].endsWith(',00')) {
      // Remove the ',00' from the end of the numeric value
      const newValue = val[2].slice(0, -3);
      // assign the modified value to the innerText property
      value.innerText = `${val[1]}${newValue}`;
    }

    return value;
  }

  // Apply formatting to each item price
  itemPrice.forEach((price) => {
    formatPrice(price);
  });

  // Apply formatting to the cart subtotal
  if (cartTotal) formatPrice(cartTotal);
};
/* eslint-enable */
// Slide Cart Edits - End
